import React from 'react';
import Review from './Review';

const ReviewPage = () => {
  return <Review />;
};

export default ReviewPage;
